import React from 'react';
import * as IptC from './_ccbIptC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as LblC from './_cccLblC';
import * as BtnsC from './_ccmBtnsC';
import * as HdrC from './_ccmHdrC';
import * as RootC from './_ccmRootC';
import * as SchC from './_ccmSchC';
import * as TblC from './_ccmTblC';
import * as _cm from './_cm';
import { a } from './_cmABT';
import * as _cmFLE from './_cmFLE';
import * as _cmFTH from './_cmFTH';
import * as _cmPDF from './_cmPDF';
import * as _cr from './_cr';
import { useFilez } from './_csMdlFile';
import { useCfmz } from './_csMdlCfm';
import { useLdrz } from './_csLdr';
import * as _ls from './_csLcl';
import * as _gv from './_gv';
import * as _hm from './_hm';
import * as _hmDTM from './_hmDTM';
import * as _hmXLS from './_hmXLS';
import * as _ht from './_ht';

import * as icm from './icm';
import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';
import { Button } from 'react-native';

const $cz = {
  tgt: '配付状況',
  dw1: 35,
  lblDw: 19,
};

const $pz = {
  vlez: {
    bSch: true, // $schAsync が終わるまで、配布状況を追加は無効
  }
};

let $iz1z = {} as _ht.dz;
let $i19z = {} as _ht.dz;

let $iz1rs = [] as _ht.ls;

let $_10rs = [] as _ht.ls;
let $i11rs = [] as _ht.ls; // 契約終了を含む
let $i11rs2 = [] as _ht.ls; // 契約終了を除く
let $i12rs = [] as _ht.ls;
let $i15rs = [] as _ht.ls;
let $i18rs = [] as _ht.ls;

let $iz1r_fst = -1;

let $i18r_fst = -1;

const $schz = {
  i11ri15r1f: -1, // 地区
  i11ri18r1f: -1, // 支払方法
  i11r_fst: -1, // 店舗
  i11rt1100i: -1, // 店種
  iz1r_10r9k: -1, // 登録者
  iz1r_icn: '', // 伝票番号
  iz1r_10r1k: -1, // 受注者
  iz1r_10r2k: -1, // 配付者
  iz1rd1100sStt: '', // 受注日
  iz1rd1100sEnd: '', // 受注日
  iz1rd1200sStt: '', // 配付実績日
  iz1rd1200sEnd: '', // 配付実績日
  iz1rd1220sStt: '', // 配付予定日
  iz1rd1220sEnd: '', // 配付予定日
  iz1rd1500sStt: '', // 入金確認日
  iz1rd1500sEnd: '', // 入金確認日
  iz1rs1100i: 20, // 対応状況
  iz1ra2n00s: '', // シリアルNo.
};

const $cvtIz1rz = (
  iz1rz: _ht.dz, // top で引用することを前提に iz1rz を引数とする
) => {
  const _i11rz = _hm.get1(iz1rz?.cldz?.i11rs, {});
  const _i15rz = _hm.get1(_i11rz?.cldz?.i15rs, {});
  const _i18rz = _hm.get1(_i11rz?.cldz?.i18rs, {});
  const __10r1z = _hm.get1(iz1rz?.cldz?._10r1s, {});
  const __10r2z = _hm.get1(iz1rz?.cldz?._10r2s, {});
  const __10r9z = _hm.get1(iz1rz?.cldz?._10r9s, {});
  const _dz = {
    ... _i11rz,
    i11r_icn: _i11rz._icn,
    i11r_pfx: _i11rz._pfx,
    i11rt1100is: _cm.r($i12rs, _i11rz.i11rt1100i)?.text,
    ... _i15rz,
    i15r_icn: _i15rz._icn,
    i15r_pfx: _i15rz._pfx,
    ... _i18rz,
    i18r_icn: _i18rz._icn,
    i18r_pfx: _i18rz._pfx,
    _10r1_icn: __10r1z._icn,
    _10r1_pfx: __10r1z._pfx,
    _10r2_icn: __10r2z._icn,
    _10r2_pfx: __10r2z._pfx,
    _10r9_icn: __10r9z._icn,
    _10r9_pfx: __10r9z._pfx,
    ... iz1rz,
    iz1r_icn: iz1rz._icn,
    iz1r_pfx: iz1rz._pfx,
    iz1rs1100is: _cm.r(icv.lz.iz1rs1100i, iz1rz.iz1rs1100i)?.text,
    iz1ra1100is: _cm.r(icv.lz.iz1ra1100i, iz1rz.iz1ra1100i)?.text,
  }
  return _dz;
};

const $eptCsv1 = (
  sLdrz: _ht.dz
) => { // 配付CSV

  if (_hm.f($iz1rs) == false) return;

  sLdrz?.show();

  const _bdys = $iz1rs.map( (_iz1rz: _ht.dz) => {
    const _iz1rz2 = $cvtIz1rz(_iz1rz);
    return {
      1: _iz1rz2.i15r_pfx,
      2: _iz1rz2.i11r_icn,
      3: _iz1rz2.i11r_pfx,
      4: _iz1rz2.i11rt1100is,
      5: _iz1rz2._10r9_pfx,
      6: _iz1rz2.iz1r_icn,
      7: _iz1rz2.iz1rs1100is,
      8: _iz1rz2._10r1_pfx,
      9: _iz1rz2.iz1rd1100s,
      10: _iz1rz2.iz1ra1100i,
      11: _iz1rz2._10r2_pfx,
      12: _iz1rz2.iz1rd1220s,
      13: _iz1rz2.iz1rd1200s,
      14: _iz1rz2.iz1ra4300i,
      15: _iz1rz2.iz1ra4400i,
      16: _iz1rz2.i18r_pfx,
      17: _iz1rz2.iz1rd1500s,
    }
  });

  _cmFLE.eptCsv({
    hdrz: {
      1: '地区',
      2: '顧客NO', //
      3: '販売店',
      4: '店種',
      5: '登録者',
      6: '伝票番号',
      7: '対応状況',
      8: '受注者',
      9: '受注日',
      10: '受注冊数',
      11: '配付者',
      12: '配付予定日',
      13: '配付実績日',
      14: '販売金額', //
      15: '請求金額', //
      16: '支払方法', //
      17: '入金確認日', //
    },
    bdys: _bdys,
    fileName: `配付_${_hmDTM.getTdy()}.csv`,
  })  

  sLdrz?.hide();

};

const $eptCsv2 = (
  sCfmz: _ht.dz,
  sLdrz: _ht.dz
) => { // 請求CSV

  if (
    !($i18r_fst > 0) ||
    !_hm.f($schz.iz1rd1200sStt) ||
    !_hm.f($schz.iz1rd1200sEnd)
  ) {
    sCfmz.show({
      abtz: icv.abtz.btnNextz,
      text: '支払方法・配付実績日を指定し検索してください。',
      ls: [
        { key: 1, text: 'はい' }
      ]
    });
    return;
  };

  sLdrz?.show();

  //const _dz = {} as _ht.dz;
  let _oldz = {} as _ht.dz;
  const _bdys = [] as _ht.ls;

  const _grtYearMth = (iz1rd1200s: _ht.s) => _hmDTM.f(iz1rd1200s, 'YYYY-MM');

  const _sumz = {} as _ht.dz;
  $iz1rs.map((_iz1rz: _ht.dz) => {
    const _iz1rz2 = $cvtIz1rz(_iz1rz);
    if (!_sumz[_iz1rz2.i11r_icn])  {
      _sumz[_iz1rz2.i11r_icn] = {} as _ht.dz;
    }
    const _yearMth = _grtYearMth(_iz1rz2.iz1rd1200s);
    if (!_sumz[_iz1rz2.i11r_icn][_yearMth])  {
      _sumz[_iz1rz2.i11r_icn][_yearMth] = {
        iz1ra1100iSum: 0,
        iz1ra4300iSum: 0, 
        csnSum: 0, // comission 
        tax1: 0,
        tax2: 0,
      };
    }
    const _csn = _iz1rz2.iz1ra4300i - _iz1rz2.iz1ra4400i;
    _sumz[_iz1rz2.i11r_icn][_yearMth].iz1ra1100iSum += _iz1rz2.iz1ra1100i;
    _sumz[_iz1rz2.i11r_icn][_yearMth].iz1ra4300iSum += _iz1rz2.iz1ra4300i;
    _sumz[_iz1rz2.i11r_icn][_yearMth].csnSum += _csn;
    _sumz[_iz1rz2.i11r_icn][_yearMth].tax1 += _hm.cvtFlr(_iz1rz2.iz1ra4300i * (1.0 - 1.0 / 1.1))
    _sumz[_iz1rz2.i11r_icn][_yearMth].tax2 += _hm.cvtFlr(_csn * (1.0 - 1.0 / 1.1));
  });

  const _cntz = {} as _ht.dz;
  $iz1rs
  .filter((_iz1rz: _ht.dz) => _iz1rz.iz1rs1100i == 30)
  .sort((iz1rz1: _ht.dz, iz1rz2: _ht.dz) => {
    const _iz1rz1 = $cvtIz1rz(iz1rz1);
    const _iz1rz2 = $cvtIz1rz(iz1rz2);
    if (_iz1rz1.iz1rd1100s > _iz1rz2.iz1rd1100s) return  1;
    if (_iz1rz1.iz1rd1100s < _iz1rz2.iz1rd1100s) return -1;
    return 0;
  })
  .sort((iz1rz1: _ht.dz, iz1rz2: _ht.dz) => {
    const _iz1rz1 = $cvtIz1rz(iz1rz1);
    const _iz1rz2 = $cvtIz1rz(iz1rz2);
    if (_iz1rz1.i11r_icn > _iz1rz2.i11r_icn) return  1;
    if (_iz1rz1.i11r_icn < _iz1rz2.i11r_icn) return -1;
    return 0;
  })
  .map( (_iz1rz: _ht.dz) => {
    const _iz1rz2 = $cvtIz1rz(_iz1rz);
    if (!_cntz[_iz1rz2.i11r_icn]) _cntz[_iz1rz2.i11r_icn] = 0;
    _cntz[_iz1rz2.i11r_icn] += 1;
    if (_cntz[_iz1rz2.i11r_icn] == 1) { // 1行目のみ出力
      let _sum = 0;
      const _cnt = Object.keys(_sumz[_iz1rz2.i11r_icn]).length;
      Object.keys(_sumz[_iz1rz2.i11r_icn])
      .sort((_yearMth1: _ht.s, _yearMth2: _ht.s) => {
        if (_yearMth1 > _yearMth2) return  1;
        if (_yearMth1 < _yearMth2) return -1;
        return 0;
      })
      .map((_yearMth: _ht.s, _idx: _ht.n) => {
        _sum += _sumz[_iz1rz2.i11r_icn][_yearMth].iz1ra4300iSum - _sumz[_iz1rz2.i11r_icn][_yearMth].csnSum;
        const _mth = _hmDTM.f(_yearMth + '-01', '月', false);
        if (_idx == 0) {
          _oldz = {
            1: _hmDTM.cvtLdm(_iz1rz2.iz1rd1200s),
            2: _iz1rz2.i11ra2100s,
            3: _iz1rz2.i11ra2200s,
            4: _iz1rz2.i11r_pfx,
            5: _iz1rz2.i11ra3120s,
            6: String(_iz1rz2.i11ra4100s).replace(/-/g, ''),
            7: '',
            8: '',
            9: _iz1rz2.i11ra2100s,
            10: _iz1rz2.i11ra2200s,
            11: _iz1rz2.i11r_pfx,
            12: _iz1rz2.i11ra3120s,
            13: String(_iz1rz2.i11ra4100s).replace(/-/g, ''),
            14: `${_mth}納付券/内消費税10%${_sumz[_iz1rz2.i11r_icn][_yearMth].tax1}円`,
            15: icv.cz.itemz.prc,
            16: _sumz[_iz1rz2.i11r_icn][_yearMth].iz1ra1100iSum,
            17: '',
            18: '',
            19: '',
            20: '',
            21: _iz1rz2.i11r_icn,
            22: '',
            23: '',
            24: _hmDTM.cvtLdm(_yearMth + '-01'),
            25: _iz1rz2.i11r_icn,
            26: '',
            27: '',
            28: '',
            29: 1,
            30: 10,
          };
          _bdys.push(_oldz);
          _oldz = {
            1: '',
            2: '',
            3: '',
            4: '',
            5: '',
            6: '',
            7: '',
            8: '',
            9: '',
            10: '',
            11: '',
            12: '',
            13: '',
            14: `${_mth}手数料/内消費税10%${_sumz[_iz1rz2.i11r_icn][_yearMth].tax2}円`,
            15: icv.cz.itemz.csn * -1,
            16: _sumz[_iz1rz2.i11r_icn][_yearMth].iz1ra1100iSum,
            17: '',
            18: '',
            19: (_idx == _cnt - 1) ? _sum : '',
            20: '',
            21: '',
            22: '',
            23: '',
            24: '',
            25: '',
            26: '',
            27: '',
            28: '',
            29: 1,
            30: 10,
          };
          _bdys.push(_oldz);
        }
        else {
          _oldz = {
            1: '',
            2: '',
            3: '',
            4: '',
            5: '',
            6: '',
            7: '',
            8: '',
            9: '',
            10: '',
            11: '',
            12: '',
            13: '',
            14: `${_mth}納付券/内消費税10%${_sumz[_iz1rz2.i11r_icn][_yearMth].tax1}円`,
            15: icv.cz.itemz.prc,
            16: _sumz[_iz1rz2.i11r_icn][_yearMth].iz1ra1100iSum,
            17: '',
            18: '',
            19: '',
            20: '',
            21: '',
            22: '',
            23: '',
            24: _hmDTM.cvtLdm(_yearMth + '-01'),
            25: '',
            26: '',
            27: '',
            28: '',
            29: 1,
            30: 10,
          };
          _bdys.push(_oldz);
          _oldz = {
            1: '',
            2: '',
            3: '',
            4: '',
            5: '',
            6: '',
            7: '',
            8: '',
            9: '',
            10: '',
            11: '',
            12: '',
            13: '',
            14: `${_mth}手数料/内消費税10%${_sumz[_iz1rz2.i11r_icn][_yearMth].tax2}円`,
            15: icv.cz.itemz.csn * -1,
            16: _sumz[_iz1rz2.i11r_icn][_yearMth].iz1ra1100iSum,
            17: '',
            18: '',
            19: (_idx == _cnt - 1) ? _sum : '',
            20: '',
            21: '',
            22: '',
            23: '',
            24: '',
            25: '',
            26: '',
            27: '',
            28: '',
            29: 1,
            30: 10,
          };
          _bdys.push(_oldz);
        }
      })
    }
  });

  _cmFLE.eptCsv({
    hdrz: {
      1: '注文日', // 月末日
      2: '郵便番号',
      3: '住所',
      4: '氏名',
      5: '氏名カナ',
      6: '電話番号',
      7: 'メールアドレス',
      8: '職業',
      9: '別配送先郵便番号',
      10: '別配送先住所',
      11: '別配送先氏名',
      12: '別配送先氏名カナ',
      13: '別配送電話番号',
      14: '商品名',
      15: '単価',
      16: '数量',
      17: '送料',
      18: '店舗手数料',
      19: '請求金額合計',
      20: '受付サイト',
      21: '任意注文番号', // 顧客NO
      22: '備考',
      23: '外税額',
      24: '役務提供予定日',
      25: '加盟店顧客番号',
      26: '法人名',
      27: '部署名',
      28: '担当者名',
      29: '請求書別送',
      30: '消費税率',

    },
    bdys: _bdys,
    fileName: `請求_${_hmDTM.getTdy()}.csv`,
  })  
  sLdrz?.hide();
};

const $eptExl1Async = async ( // 配付実績表
  sCfmz: _ht.dz,
  sLdrz: _ht.dz,
) => {

  if (_hm.f($iz1rs) == false) return;

  const _shtName = '大型ごみ受付業務';

  const _wbk = _hmXLS.crtWbk();
  const _wst = _hmXLS.addSht(_wbk, _shtName);

  const _uW = 5.1;
  const _uH = 27.85;
  const _uF = 1;

  let _sttDate = '';
  let _endDate = '';
  const _dz = {} as _ht.dz;
  $iz1rs.map((iz1rz: _ht.dz, idx: _ht.n) => {
    if (iz1rz.iz1rs1100i >= 30) {
      const _iz1rd1200s = iz1rz.iz1rd1200s;
      if (_sttDate == '' || _iz1rd1200s <= _sttDate) _sttDate = _iz1rd1200s;
      if (_endDate == '' || _iz1rd1200s >= _endDate) _endDate = _iz1rd1200s;
      if (!_dz[_iz1rd1200s]) {
        _dz[_iz1rd1200s] = {
          iz1rCnt: 0, // 受注件数
          iz1ra1100iSum: 0, // 受注冊数
          iz1ra4300iSum: 0, // 販売金額
          iz1ra4400iSum: 0, // 請求金額
        };
      }
      _dz[_iz1rd1200s].iz1rCnt += 1;
      _dz[_iz1rd1200s].iz1ra1100iSum += iz1rz.iz1ra1100i;
      _dz[_iz1rd1200s].iz1ra4300iSum += iz1rz.iz1ra4300i;
      _dz[_iz1rd1200s].iz1ra4400iSum += iz1rz.iz1ra4400i;
    }
  });

  if (
    !_hm.f($schz.iz1rd1200sStt) ||
    !_hm.f($schz.iz1rd1200sEnd) ||
    (_hmDTM.f(_sttDate, 'YYYYMM') != _hmDTM.f(_endDate, 'YYYYMM'))
  ) {
    sCfmz.show({
      abtz: icv.abtz.btnNextz,
      text: '配付実績日を指定し検索してください。',
      ls: [
        { key: 1, text: 'はい' }
      ]
    });
    return;
  }

  sLdrz?.show();

  _hmXLS.setW(_wst, 1, _uW * 1.38);
  _hmXLS.setW(_wst, 2, _uW * 1.38);
  _hmXLS.setW(_wst, 3, _uW * 1.38 * 2.5);
  _hmXLS.setW(_wst, 4, _uW * 1.38 * 2.5);
  _hmXLS.setW(_wst, 5, _uW * 1.38 * 2.5);
  _hmXLS.setW(_wst, 6, _uW * 1.38 * 2.5);
  _hmXLS.setW(_wst, 7, _uW * 1.38 * 2.5);

  let _row = 0;

  _row += 1;
  _hmXLS.mrgCells(_wst, _row, 1, _row, 7);
  _hmXLS.setVle(_wst, _row, 1, '大型ごみ等処理手数料徴収等業務');
  _hmXLS.setH(_wst, _row, _uH * 1.06);
  _hmXLS.setAmt(_wst, _row, 1, { vertical: 'middle', horizontal: 'center', wrapText: true });

  _hmXLS.setFont(_wst, _row, 1, { size: 14 * _uF, bold: true });

  _row += 1;
  _hmXLS.setVle(_wst, _row, 1, _hmDTM.f(_sttDate, '元号') + '度 ' + _hmDTM.f(_sttDate, '月', false) + '分');
  _hmXLS.setVle(_wst, _row, 7, $i19z.i19rz._pfx);

  _hmXLS.setH(_wst, _row, _uH * 0.71);

  _hmXLS.setAmt(_wst, _row, 1, { vertical: 'middle', horizontal: 'left', wrapText: false });

  _hmXLS.setFont(_wst, _row, 1, { size: 12 * _uF });

  _hmXLS.setAmt(_wst, _row, 7, { vertical: 'middle', horizontal: 'right', wrapText: false });

  _hmXLS.setFont(_wst, _row, 1, { size: 12 * _uF });

  _row += 1;
  _hmXLS.setH(_wst, _row, _uH * 0.71);

  _row += 1;
  _hmXLS.setVle(_wst, _row, 1, '日付');
  _hmXLS.setVle(_wst, _row, 2, '曜日');
  _hmXLS.setVle(_wst, _row, 3, '配付実績件数');
  _hmXLS.setVle(_wst, _row, 4, '大型ごみ等処理手数料納付券（冊数）');
  _hmXLS.setVle(_wst, _row, 5, '販売金額');
  _hmXLS.setVle(_wst, _row, 6, '請求金額');
  _hmXLS.setVle(_wst, _row, 7, '備考');

  _hmXLS.setH(_wst, _row, _uH * 0.71 * 2);
  _hm.getRng(7,1).map((cmn: _ht.n) => {
    _hmXLS.setAmt(_wst, _row, cmn, { vertical: 'middle', horizontal: 'center', wrapText: true });
    _hmXLS.setBdr(_wst, _row, cmn, { 
      top: { style: 'thick', color: { argb: '000000' }},
      bottom: { style: 'thick', color: { argb: '000000' }},
      left: { style: cmn == 1 ? 'thick' : 'thin', color: { argb: '000000' }},
      right: { style: cmn == 7 ? 'thick' : 'thin', color: { argb: '000000' }},
    });
    _hmXLS.setFont(_wst, _row, cmn, { size: cmn == 4 ? (9 * _uF) : (12 * _uF) });
  })

  _hm.getRng(32,1).map((cnt: _ht.n) => {

    _row += 1;

    const date = _hmDTM.addDay(_hmDTM.cvtFdm(_sttDate), cnt - 1);

    if (_hmDTM.f(date, 'YYYYMM') == _hmDTM.f(_sttDate, 'YYYYMM')) {
      _hmXLS.setVle(_wst, _row, 1, _hmDTM.cvtDay(date));
      _hmXLS.setVle(_wst, _row, 2, _hmDTM.cvtDow(date));
      if (_dz[date]) {
        _hmXLS.setVle(_wst, _row, 3, _dz[date].iz1rCnt);
        _hmXLS.setVle(_wst, _row, 4, _dz[date].iz1ra1100iSum);
        _hmXLS.setVle(_wst, _row, 5, _dz[date].iz1ra4300iSum);
        _hmXLS.setVle(_wst, _row, 6, _dz[date].iz1ra4400iSum);
      }
    }

    _hmXLS.setH(_wst, _row, _uH * 0.71);
    _hm.getRng(7,1).map((cmn: _ht.n) => {
      _hmXLS.setAmt(_wst, _row, cmn, { vertical: 'middle', horizontal: _hm.i(cmn, [1,3,4,5,6]) ? 'right' : 'center', wrapText: true });
      _hmXLS.setBdr(_wst, _row, cmn, { 
        top: { style: 'thin', color: { argb: '000000' }},
        bottom: { style: 'thin', color: { argb: '000000' }},
        left: { style: cmn == 1 ? 'thick' : 'thin', color: { argb: '000000' }},
        right: { style: cmn == 7 ? 'thick' : 'thin', color: { argb: '000000' }},
      });
      _hmXLS.setFont(_wst, _row, cmn, { size: (12 * _uF) });
      _hmXLS.setFmt(_wst, _row, cmn, _hm.i(cmn, [3]) ? '#,##0件;-#,##0件' : _hm.i(cmn, [4]) ? '#,##0冊;-#,##0冊' : _hm.i(cmn, [5,6]) ? '#,##0円;-#,##0円' : undefined);
    })

  })

  _row += 1;

  _hmXLS.mrgCells(_wst, _row, 1, _row, 2);
  _hmXLS.setVle(_wst, _row, 1, '計');

  _hmXLS.setFml(_wst, _row, 3, `TEXT(SUM(C5:C36), "#,###") & "件"`);
  _hmXLS.setFml(_wst, _row, 4, `TEXT(SUM(D5:D36), "#,###") & "冊"`);
  _hmXLS.setFml(_wst, _row, 5, `TEXT(SUM(E5:E36), "#,###") & "円"`);
  _hmXLS.setFml(_wst, _row, 6, `TEXT(SUM(F5:F36), "#,###") & "円"`);

  _hmXLS.setH(_wst, _row, _uH * 0.71);
  _hm.getRng(7,1).map((cmn: _ht.n) => {
    _hmXLS.setAmt(_wst, _row, cmn, { vertical: 'middle', horizontal: _hm.i(cmn, [3,4,5,6]) ? 'right' : 'center', wrapText: false });
    _hmXLS.setBdr(_wst, _row, cmn, { 
      top: { style: 'double', color: { argb: '000000' }},
      bottom: { style: 'thick', color: { argb: '000000' }},
      left: { style: _hm.i(cmn, [1, 2]) ? 'thick' : 'thin', color: { argb: '000000' }},
      right: { style: cmn == 7 ? 'thick' : 'thin', color: { argb: '000000' }},
    });
    _hmXLS.setFont(_wst, _row, cmn, { size: (12 * _uF) });
  })

  _hmXLS.fitPageW(_wst);

  const _fileName = `報告書_${_hmDTM.f(_sttDate, 'YYYYMM')}.xlsx`;

  _hmXLS.dldWbkAsync(_wbk, _fileName);

  sLdrz?.hide();

};

const $eptPdf1Async = async ( // 領収書兼受領書
  sLdrz: _ht.dz
) => {

  if (_hm.f($iz1z.iz1rz) == false) return;

  sLdrz?.show();

  const _iz1rz2 = $cvtIz1rz($iz1z.iz1rz);

  let _lines = [] as _ht.ls;

  let _row: _ht.n;

  _row = 0;
  _lines.push({ type: 'text', pfx: `納品書`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'c', frm: false, ts: 1.2, tb: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `伝票No.: ${_iz1rz2.iz1r_icn}`,  cmn: 36, row: _row, cmnCnt: 19, ta: 'r', rowCnt: 1, });

  _row += 1;
  _lines.push({ type: 'text', pfx: `お客様コードNo.: ${_iz1rz2.i11r_icn}`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `〒 ${_iz1rz2.i11ra2100s}`,  cmn:  1, row: _row, cmnCnt: 31, ta: 'l', ts:0.8, rowCnt: 1, });
  _lines.push({ type: 'text', pfx: $i19z.i19rz._pfx,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _lines.push({ type: 'text', pfx: `${_iz1rz2.i11ra2200s}`,  cmn:  1, row: _row, cmnCnt: 31, ta: 'l', ts:0.8, rowCnt: 1, });
  _lines.push({ type: 'text', pfx: '〒 ' + $i19z.i19rz.i19ra1100s,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  const _pfxs1 = String(_iz1rz2.i11r_pfx + ' 御中').split('　');
  _pfxs1.map((_pfx: _ht.s, _idx: _ht.n) => {
    _lines.push({ type: 'text', pfx: _pfx,  cmn:  1, row: _row + _idx, cmnCnt: 31, ta: 'l', ts:0.8, rowCnt: 1, });
  })
  _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra1200s,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _lines.push({ type: 'text', pfx: 'TEL:' + $i19z.i19rz.i19ra2100s + ' FAX:' + $i19z.i19rz.i19ra2200s,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra4210s ?? '',  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _lines.push({ type: 'text', pfx: `下記の通り納品いたしますのでご査収ください。`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'l', rowCnt: 1, });

  _row += 1;
  _row += 1;

  _lines.push({ type: 'text', pfx: `品名`,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `数量`,  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `単位`,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `単価`,  cmn: 26, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `金額`,  cmn: 31, row: _row, cmnCnt: 7, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `備考`,  cmn: 38, row: _row, cmnCnt: 16, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});

  _row += 1;
  _lines.push({ type: 'text', pfx: icv.cz.itemz.text,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: String(_iz1rz2.iz1ra1100i),  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: icv.cz.itemz.unit,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(icv.cz.itemz.prc),  cmn: 26, row: _row, cmnCnt: 5, ta: 'r', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1rz2.iz1ra4300i),  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 1, frm: false });
  const _iz1ra3100ss1 = String(_iz1rz2.iz1ra3100s).split('　');
  _iz1ra3100ss1.map((_iz1ra3100s: _ht.s, _idx: _ht.n) => {
    _lines.push({ type: 'text', pfx: _iz1ra3100s,  cmn: 38, row: _row + _idx, cmnCnt: 16, ta: 'l', ts:0.8, rowCnt: 1, frm: false });
  })

  _lines.push({ type: 'text', pfx: '',  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 26, row: _row, cmnCnt: 5, ta: 'r', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 38, row: _row, cmnCnt: 16, ta: 'l', rowCnt: 7, frm: true });

  _row += 1;
  _row += 1;
  _row += 1;
  _row += 1;
  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `販売手数料(10%+消費税)`,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: String(_iz1rz2.iz1ra1100i),  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: `冊`,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '-' + _hm.cvtCmm(icv.cz.itemz.prc - icv.cz.itemz.blg),  cmn: 26, row: _row, cmnCnt: 5, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '-' + _hm.cvtCmm(_iz1rz2.iz1ra4300i-_iz1rz2.iz1ra4400i),  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 38, row: _row, cmnCnt: 16, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `${_hmDTM.f(_iz1rz2.iz1rd1100s,'年月日', false)} ご注文分`,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: ``,  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: ``,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: `合計`,  cmn: 26, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1rz2.iz1ra4400i),  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 38, row: _row, cmnCnt: 16, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `納品日　　　：　　　　年　　月　　日`,  cmn: 25, row: _row, cmnCnt: 29, ta: 'l', rowCnt: 1, });

  _row += 1;
  _row += 1;
  _row += 1;

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `受領書`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'c', frm: false, ts: 1.2, tb: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `伝票No.: ${_iz1rz2.iz1r_icn}`,  cmn: 36, row: _row, cmnCnt: 19, ta: 'r', rowCnt: 1, });

  _row += 1;

  _row += 1;
  _lines.push({ type: 'text', pfx: `お客様コードNo.: ${_iz1rz2.i11r_icn}`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `〒 ${_iz1rz2.i11ra2100s}`,  cmn:  1, row: _row, cmnCnt: 31, ta: 'l', ts:0.8, rowCnt: 1, });
  _lines.push({ type: 'text', pfx: $i19z.i19rz._pfx,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _lines.push({ type: 'text', pfx: `${_iz1rz2.i11ra2200s}`,  cmn:  1, row: _row, cmnCnt: 31, ta: 'l', ts:0.8, rowCnt: 1, });
  _lines.push({ type: 'text', pfx: '〒 ' + $i19z.i19rz.i19ra1100s,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  const _pfxs2 = String(_iz1rz2.i11r_pfx + ' 御中').split('　');
  _pfxs2.map((_pfx: _ht.s, _idx: _ht.n) => {
    _lines.push({ type: 'text', pfx: _pfx,  cmn:  1, row: _row + _idx, cmnCnt: 31, ta: 'l', ts:0.8, rowCnt: 1, });
  })
  _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra1200s,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _lines.push({ type: 'text', pfx: 'TEL:' + $i19z.i19rz.i19ra2100s + ' FAX:' + $i19z.i19rz.i19ra2200s,  cmn: 32, row: _row, cmnCnt: 22, ta: 'l', ts:0.8, rowCnt: 1, });

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `下記の通り受領いたしました。`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'l', rowCnt: 1, });

  _row += 1;
  _row += 1;

  _lines.push({ type: 'text', pfx: `品名`,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `数量`,  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `単位`,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `単価`,  cmn: 26, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `金額`,  cmn: 31, row: _row, cmnCnt: 7, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
  _lines.push({ type: 'text', pfx: `備考`,  cmn: 38, row: _row, cmnCnt: 16, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});

  _row += 1;
  _lines.push({ type: 'text', pfx: icv.cz.itemz.text,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: String(_iz1rz2.iz1ra1100i),  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: icv.cz.itemz.unit,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(icv.cz.itemz.prc),  cmn: 26, row: _row, cmnCnt: 5, ta: 'r', rowCnt: 1, frm: false });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1rz2.iz1ra4300i),  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 1, frm: false });
  const _iz1ra3100ss2 = String(_iz1rz2.iz1ra3100s).split('　');
  _iz1ra3100ss2.map((_iz1ra3100s: _ht.s, _idx: _ht.n) => {
    _lines.push({ type: 'text', pfx: _iz1ra3100s,  cmn: 38, row: _row + _idx, cmnCnt: 16, ta: 'l', ts:0.8, rowCnt: 1, frm: false });
  })

  _lines.push({ type: 'text', pfx: '',  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 26, row: _row, cmnCnt: 5, ta: 'r', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 7, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 38, row: _row, cmnCnt: 16, ta: 'l', rowCnt: 7, frm: true });

  _row += 1;
  _row += 1;
  _row += 1;
  _row += 1;
  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `販売手数料(10%+消費税)`,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: String(_iz1rz2.iz1ra1100i),  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: `冊`,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '-' + _hm.cvtCmm(icv.cz.itemz.prc - icv.cz.itemz.blg),  cmn: 26, row: _row, cmnCnt: 5, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '-' + _hm.cvtCmm(_iz1rz2.iz1ra4300i-_iz1rz2.iz1ra4400i),  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 38, row: _row, cmnCnt: 16, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `${_hmDTM.f(_iz1rz2.iz1rd1100s,'年月日', false)} ご注文分`,  cmn: 1, row: _row, cmnCnt: 17, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: ``,  cmn: 18, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: ``,  cmn: 22, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: `合計`,  cmn: 26, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1rz2.iz1ra4400i),  cmn: 31, row: _row, cmnCnt: 7, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '',  cmn: 38, row: _row, cmnCnt: 16, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `受領日　　　：　　　　年　　月　　日`,  cmn: 25, row: _row, cmnCnt: 29, ta: 'l', rowCnt: 1, });
  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `お客様署名欄：`,  cmn: 25, row: _row, cmnCnt: 29, ta: 'l', rowCnt: 1, });

  _lines.push({ type: 'pstCvsToPdf' });

  _lines.push({ type: 'savePdf' });

  await _cmPDF.dldFileAsync({
    lines: _lines,
    itlz: {
      orientation: 'portrait',
    },
    fileName: '納品書兼受領書',
  })

  sLdrz?.hide();

};

const $eptPdf2Async = async ( // 請求書PDF
  sCfmz: _ht.dz,
  sLdrz: _ht.dz,
) => {

  if (!($i18r_fst > 0) || !_hm.f($iz1rs)) {
    sCfmz.show({
      abtz: icv.abtz.btnNextz,
      text: '支払方法を指定し検索してください。',
      ls: [
        { key: 1, text: 'はい' }
      ]
    });
    return;
  };

  sLdrz?.show();

  const _i18rz = _hm.getDz($i18rs, $i18r_fst, '_fst');

  let _lines = [] as _ht.ls;

  let _page = 0;
  let _row = 0;

  const _lineCnt = 14; // 合計金額行の出力を考慮
  const _pageCnt = _hm.cvtFlr($iz1rs.length / _lineCnt) + 1;

  let _iz1rd1200s = ''; // 請求日は最大配付日の月末
  $iz1rs.map((_iz1rz: _ht.dz, _idx: _ht.n) => {
    const _iz1rz2 = $cvtIz1rz(_iz1rz);
    if (_iz1rz2.iz1rd1200s > _iz1rd1200s) _iz1rd1200s = _iz1rz2.iz1rd1200s;
  });
  _iz1rd1200s = _hmDTM.cvtLdm(_iz1rd1200s);

  let _iz1ra1100i = 0;
  let _iz1ra4300i = 0;
  let _iz1ra4400i = 0;
  let _tax1 = 0;
  let _tax2 = 0;

  $iz1rs.map((_iz1rz: _ht.dz, _idx: _ht.n) => {
    const _iz1rz2 = $cvtIz1rz(_iz1rz);
    _iz1ra1100i += _iz1rz2.iz1ra1100i;
    _iz1ra4300i += _iz1rz2.iz1ra4300i;
    _iz1ra4400i += _iz1rz2.iz1ra4400i;
    _tax1 += _hm.cvtFlr(_iz1rz2.iz1ra4300i * (1.0 - 1.0 / 1.1));
    _tax2 += _hm.cvtFlr((_iz1rz2.iz1ra4300i - _iz1rz2.iz1ra4400i) * (1.0 - 1.0 / 1.1));
  });

  const _setHdr = () => {
    _page += 1;
    _lines.push({ type: 'text', pfx: `${_page}/${_pageCnt}`,  cmn: 1, row: 50, cmnCnt: 55, ta: 'r', rowCnt: 1, frm: false });

    _row = 0;
    _lines.push({ type: 'text', pfx: `請求書`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'c', frm: false, ts: 1.2, tb: true });

    _row += 1;
    _lines.push({ type: 'text', pfx: _hmDTM.f(_iz1rd1200s, '年月日', false),  cmn: 36, row: _row, cmnCnt: 19, ta: 'r', rowCnt: 1, });

    _lines.push({ type: 'text', pfx: `お客様コードNo.: ${_i18rz?._icn}`,  cmn: 4, row: _row, cmnCnt: 51, ta: 'l', ts:0.8, rowCnt: 1, });

    _row += 0.5;
    _row += 1;
    _lines.push({ type: 'text', pfx: `〒 ${_i18rz?.i18ra2100s}`,  cmn:  4, row: _row, cmnCnt: 51, ta: 'l', ts:0.8, rowCnt: 1, });

    _row += 1;
    _lines.push({ type: 'text', pfx: `${_i18rz?.i18ra2200s}`,  cmn:  4, row: _row, cmnCnt: 51, ta: 'l', ts:0.8, rowCnt: 1, });

    _row += 1;
    const _pfxs1 = String(_i18rz?._pfx + ' 御中').split('　');
    _pfxs1.map((_pfx: _ht.s, _idx: _ht.n) => {
      _lines.push({ type: 'text', pfx: _pfx,  cmn:  4, row: _row + _idx, cmnCnt: 51, ta: 'l', ts:0.8, rowCnt: 1, });
    })

    _row += 0.5;
    _row += 1;
    _row += 1;
    _row += 1;
    _row += 1;
    _lines.push({ type: 'text', pfx: _page == 1 ? `下記の通り御請求申し上げます。` : `（前頁からの続きです）`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'l', rowCnt: 1, });

    _row += 1;
    _row += 0.5;
    _lines.push({ type: 'text', pfx: `請求金額合計`,  cmn: 1, row: _row, cmnCnt: 20, ta: 'c', tc: 'white', rowCnt: 1, frm: true, sc: 'black' });
    _row += 1;
    _lines.push({ type: 'text', pfx: `￥` + _hm.cvtCmm(_iz1ra4400i),  cmn: 1, row: _row, cmnCnt: 20, ta: 'c', rowCnt: 1, frm: true });

    _row -= 9;
    _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra4210s ?? '',  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.6, rowCnt: 1, });

    _row += 0.8;
    _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra4220s ?? '',  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.6, rowCnt: 1, });

    _row += 0.8;
    _row += 0.4;
    _lines.push({ type: 'text', pfx: $i19z.i19rz._pfx,  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.8, rowCnt: 1, });

    _row += 1;
    _lines.push({ type: 'text', pfx: '〒 ' + $i19z.i19rz.i19ra1100s,  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.8, rowCnt: 1, });

    _row += 1;
    _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra1200s,  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.7, rowCnt: 1, });

    _row += 1;
    _lines.push({ type: 'text', pfx: 'TEL:' + $i19z.i19rz.i19ra2100s + ' FAX:' + $i19z.i19rz.i19ra2200s,  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.8, rowCnt: 1, });

    _row += 1.2;
    _lines.push({ type: 'text', pfx: '（お振込先）　※振込手数料は弊社にて負担致します',  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.6, rowCnt: 1, });
    _row += 0.8;
    _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra3100s ?? '',  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.6, rowCnt: 1, });
    _row += 0.8;
    _lines.push({ type: 'text', pfx: $i19z.i19rz.i19ra3120s ?? '',  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:0.6, rowCnt: 1, });
    _row += 1.4;
    _lines.push({ type: 'text', pfx: `支払期限：${_hmDTM.f(_hmDTM.cvtLdm(_hmDTM.addMth(_hmDTM.cvtFdm(_iz1rd1200s), 1)), '年月日', false)}`,  cmn: 30, row: _row, cmnCnt: 25, ta: 'l', ts:1.0, rowCnt: 1, });

    _row += 0.5;
    _row += 1;
    //_lines.push({ type: 'text', pfx: `配送先`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _lines.push({ type: 'text', pfx: `納付券販売`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _row += 1;
    _lines.push({ type: 'text', pfx: ``,  cmn: 1, row: _row, cmnCnt: 3, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _lines.push({ type: 'text', pfx: `ご注文日`,  cmn: 4, row: _row, cmnCnt: 12, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _lines.push({ type: 'text', pfx: `品名`,  cmn: 16, row: _row, cmnCnt: 14, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _lines.push({ type: 'text', pfx: `数量`,  cmn: 30, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _lines.push({ type: 'text', pfx: `単位`,  cmn: 35, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
//    _lines.push({ type: 'text', pfx: `単価(税込)`,  cmn: 42, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _lines.push({ type: 'text', pfx: `単価(税込)`,  cmn: 39, row: _row, cmnCnt: 8, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});
    _lines.push({ type: 'text', pfx: `金額`,  cmn: 47, row: _row, cmnCnt: 8, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});

  };
  _setHdr();

  $iz1rs.map((_iz1rz: _ht.dz, _idx: _ht.n) => {

    const _iz1rz2 = $cvtIz1rz(_iz1rz);

    _row += 1;
    _lines.push({ type: 'text', pfx: _iz1rz2.i11r_pfx,  cmn: 1, row: _row, cmnCnt: 54, ta: 'l', rowCnt: 1, frm: true });
    _row += 1;
    _lines.push({ type: 'text', pfx: '',  cmn: 1, row: _row, cmnCnt: 3, ta: 'c', rowCnt: 1, frm: true });
    _lines.push({ type: 'text', pfx: _hmDTM.f(_iz1rz2.iz1rd1100s, '年月日', false),  cmn: 4, row: _row, cmnCnt: 12, ta: 'c', rowCnt: 1, frm: true });
    _lines.push({ type: 'text', pfx: icv.cz.itemz.text,  cmn: 16, row: _row, cmnCnt: 14, ta: 'c', rowCnt: 1, frm: true });
    _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1rz2.iz1ra1100i),  cmn: 30, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, frm: true });
    _lines.push({ type: 'text', pfx: icv.cz.itemz.unit,  cmn: 35, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
//    _lines.push({ type: 'text', pfx: _hm.cvtCmm(icv.cz.itemz.prc),  cmn: 42, row: _row, cmnCnt: 5, ta: 'r', rowCnt: 1, frm: true });
    _lines.push({ type: 'text', pfx: _hm.cvtCmm(icv.cz.itemz.prc),  cmn: 39, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });
    _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1rz2.iz1ra4300i),  cmn: 47, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });

    if ( (_idx + 1) > 1 && (_idx + 1) % _lineCnt == 0) {
      _lines.push({ type: 'text', pfx: `（次頁に続きます）`,  cmn: 1, row: 48, cmnCnt: 55, ta: 'r', rowCnt: 1, frm: false });
      _lines.push({ type: 'pstCvsToPdf' });
      _lines.push({ type: 'clrCvs' });
      _lines.push({ type: 'addNewPageToPdf' });
      _setHdr();
    }

  });

  _row += 1.0;
  _lines.push({ type: 'text', pfx: ` `,  cmn: 1, row: _row, cmnCnt: 54, ta: 'l', rowCnt: 0.1, frm: true, sc: 'black' });

  _row += 0.1;
  _lines.push({ type: 'text', pfx: `　A　合計（税込）`,  cmn: 1, row: _row, cmnCnt: 29, ta: 'l', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1ra1100i),  cmn: 30, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: `冊`,  cmn: 35, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(icv.cz.itemz.prc),  cmn: 39, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1ra4300i),  cmn: 47, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `　B　消費税相当額(10%)`,  cmn: 1, row: _row, cmnCnt: 46, ta: 'l', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_tax1),  cmn: 47, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `販売手数料`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});

  _row += 1;
  _lines.push({ type: 'text', pfx: `　C　販売手数料(10%+消費税)`,  cmn: 1, row: _row, cmnCnt: 29, ta: 'l', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1ra1100i),  cmn: 30, row: _row, cmnCnt: 5, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: `冊`,  cmn: 35, row: _row, cmnCnt: 4, ta: 'c', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '-' + _hm.cvtCmm(icv.cz.itemz.prc - icv.cz.itemz.blg),  cmn: 39, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '-' + _hm.cvtCmm(_iz1ra4300i-_iz1ra4400i),  cmn: 47, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `　D　消費税相当額(10%)`,  cmn: 1, row: _row, cmnCnt: 46, ta: 'l', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: '-' + _hm.cvtCmm(_tax2),  cmn: 47, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });

  _row += 1;
  _lines.push({ type: 'text', pfx: `請求額`,  cmn: 1, row: _row, cmnCnt: 54, ta: 'c', rowCnt: 1, tc: 'white', frm: true, sc: 'black'});


  _row += 1;
  _lines.push({ type: 'text', pfx: `　E　合計(A-C)`,  cmn: 1, row: _row, cmnCnt: 46, ta: 'l', rowCnt: 1, frm: true });
  _lines.push({ type: 'text', pfx: _hm.cvtCmm(_iz1ra4400i),  cmn: 47, row: _row, cmnCnt: 8, ta: 'r', rowCnt: 1, frm: true });

  _lines.push({ type: 'pstCvsToPdf' });

  _lines.push({ type: 'savePdf' });

  await _cmPDF.dldFileAsync({
    lines: _lines,
    itlz: {
      orientation: 'portrait',
    },
    fileName: '請求書',
  })

  sLdrz?.hide();

};

const $iptCsvAsync1 = (pz: {
  sPz: _ht.dz,
  sFilez: _ht.dz,
  sCfmz: _ht.dz,
  sLdrz: _ht.dz,
}) => {
  pz.sFilez.show({
    mode: 'c',
    onRead: async (_dz: _ht.dz) => {

      pz.sLdrz.show();

      const _errs = [] as _ht.ls;
      _hm.ectSrlAsync(_dz.ls.map((_dz2: _ht.dz) => async () => {
        const _i11r_icn = _hm.pdg(_dz2['任意注文番号'], 6, '0'); // 顧客NO
        const _iz1rd1200s = _hmDTM.f(_dz2['注文日']); // 配付実績日末日
        const _iz1ra4400i = Number(_dz2['顧客請求金額']);
        const _iz1rs = await _cmFTH.loadLsAsync2({
          tgt: 'iz1r.loadIz1zLsAsync',
          i11r_icn: _i11r_icn,
          iz1rd1200sStt: _hmDTM.cvtFdm(_iz1rd1200s),
          iz1rd1200sEnd: _hmDTM.cvtLdm(_iz1rd1200s),
          iz1rs1100i: 30,
        });
        let _iz1ra4400iSum = 0;
        _iz1rs?.map((iz1rz: _ht.dz) => {
          _iz1ra4400iSum += iz1rz.iz1ra4400i;
        });
        //_hm.l(`icvIz1M10Rz 1038: ${_i11r_icn}, ${_iz1rd1200s}, ${_iz1ra4400i}, ${_iz1ra4400iSum} ${_iz1ra4400iSum == _iz1ra4400i}, ${_hm.s(_iz1rs)}`);
        if ( _iz1ra4400iSum == _iz1ra4400i ) {
          await _hm.ectSrlAsync(_iz1rs?.map((iz1rz: _ht.dz) => async () => {
            const _iz1z = {
              iz1rz: { // 標準は、不要な key, text を含み ugdDzAsync でエラーとなる
                ... iz1rz,
                key: undefined,
                text: undefined,
              },
            };
            _hm.udtDz(_iz1z.iz1rz, {
              iz1rs1100i: 60,
              iz1rd1500s: _hmDTM.getTdy(),
            });
            $udtIz1z(_iz1z);
            const _rst = await _cmFTH.ugdDzAsync2({
              tgt: 'iz1r.ugdIz1zDzAsync',
              iz1z: _iz1z,
            });
            return true;
          }));
        }
        else {
          _errs.push(`（金額不一致）顧客NO：${_i11r_icn}`);
        }
        return true;
      }))
      .then(() => {
//_hm.l(`icvIz1M10Rz 1091: here`)
        if (_errs.length > 0) {
          pz.sLdrz.hide();
          pz.sCfmz.show({
            text: `取り込みを完了しましたが、一部のデータは取り込まれませんでした（${_errs.join(', ')}）`,
            ls: [
              { key: 1, text: 'はい' },
            ],
          });
        }
        else {
          pz.sLdrz.hide();
          pz.sCfmz.show({
            text: '取り込みを完了しました',
            ls: [
              { key: 1, text: 'はい' },
            ],
          });
        }
        $schAsync(pz.sPz.udtAll, pz.sLdrz, pz.sPz);
      });
    }
  });                      
};

const $schAsync = async (
  frcUdt?: () => void,
  sLdrz?: _ht.dz,
  sPz?: _ht.dz,
  bfrs?: _ht.ls,
) => {
  //_hm.l(`icvIz1M10Rz 1510: ${$pz.vlez.bSch} ${sPz?.crt.steps[0]}`);
  $pz.vlez.bSch = true;

  if (bfrs && _hm.f(bfrs)) await _hm.ectSrlAsync(bfrs); // bSch を true にした後に実行

  //_hm.l(`icvIz1M10Rz 1511: ${$pz.vlez.bSch} ${sPz?.crt.steps[0]}`);
  const _gUserz = _gv.useUserz();
  sLdrz?.show();
  if (_gUserz.crt._20rz._key >= 0) {
    $iz1rs = await _cmFTH.loadLsAsync2({
      tgt: 'iz1r.loadIz1zLsAsync',
      lwrz: {
        i11rs: true,
        i15rs: true,
        i18rs: true,
        _10r1s: true,
        _10r2s: true,
        _10r9s: true,
      },
      ... $schz,
    })
    $i18r_fst = -1; // 請求書PDFを出力するため、支払方法が単一であることを確認
    $iz1rs.map((_dz: _ht.dz) => {
      if ($i18r_fst >= -1) {
        const _i18r_fst = _dz.cldz.i11rs[0].cldz.i18rs[0]._fst;
        if (_i18r_fst) {
          if ($i18r_fst == -1) {
            $i18r_fst = _i18r_fst;
          }
          else if ($i18r_fst != _i18r_fst) {
            $i18r_fst = -2;
          }
        }
        else {
          $i18r_fst = -2;
        }
      }
    })
  }
  sLdrz?.hide();
  //_hm.l(`icvIz1M10Rz 1542: ${$pz.vlez.bSch} ${sPz?.crt.steps[0]}`);
  if (frcUdt && sPz?.crt.steps[0] == 0) {
    //_hm.l(`icvIz1M10Rz 1165: here`);
    await frcUdt();
  }
  //_hm.l(`icvIz1M10Rz 1548: ${$pz.vlez.bSch} ${sPz?.crt.steps[0]}`);
  $pz.vlez.bSch = false;
  //_hm.l(`icvIz1M10Rz 1549: ${$pz.vlez.bSch} ${sPz?.crt.steps[0]}`);
};

const $udtIz1z = (iz1z: _ht.dz) => {
  if (iz1z.iz1rz) {
    if ( _hm.f(iz1z.iz1rz?.iz1rd1100s) && iz1z.iz1rz?.iz1r_10r1k > 0 && iz1z.iz1rz?.iz1ra1100i > 0 ) { // 受注済
      if ( _hm.f(iz1z.iz1rz?.iz1rd1200s) && iz1z.iz1rz?.iz1r_10r2k > 0 ) { // 配付済

        if ( _hm.f(iz1z.iz1rz?.iz1rd1500s) ) { // 入金済
          _cm.u(iz1z.iz1rz, {
            iz1rs1100i: 60
          });
        }
        else { // 配付済
          _cm.u(iz1z.iz1rz, {
            iz1rs1100i: 30
          });
        }

      }
      else { // 受注済
        _cm.u(iz1z.iz1rz, {
          iz1rs1100i: 20
        });
      }
    }
    else { // 未受注
      _cm.u(iz1z.iz1rz, {
        iz1rs1100i: -1
      });
    }
    _cm.u(iz1z.iz1rz, {
      iz1ra4300i: (iz1z.iz1rz?.iz1ra1100i ?? 0) * icv.cz.itemz.prc,
      iz1ra4400i: (iz1z.iz1rz?.iz1ra1100i ?? 0) * icv.cz.itemz.blg,
    });
  }
};

export const R = (pz: {
  sRz: _ht.dz,
}) => {

  const _gUserz = _gv.useUserz();

  const _sPz = _ls.usePz({
    steps: [0,0],
    phs: 'd',
  });

  return (
    _cr.c(icvBaseM10Rz.N, {},
      _cr.c(RootC.N, {
        sPz: _sPz,
        hdrClds: [
          _cr.c(H, {
            sPz: _sPz,
          })
        ],
        schStlz: a(`dw/w6`),
        schClds: [
          _cr.c(S, {
            sPz: _sPz,
          })
        ],
        btnStlz: a(`dw/w6`),
        btnClds: [
          _cr.c(B, {
            sPz: _sPz,
          })
        ],
        topStlz: a(`dw/w6`),
        topClds: [
          _cr.c(T, {
            sPz: _sPz,
          })
        ],
        cttStlz: a(`dw/w3`),
        cttClds: [
          _cr.c(C, {
            sPz: _sPz,
          })
        ],
      })
    )
  );

};

export const H = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(HdrC.N, {
      sPz: pz.sPz,
      abtz: icv.abtz.mainHdrz,
      cz: {
        tgt: $cz.tgt
      }
    })
  );
};

export const S = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(SchC.N, {
      sPz: pz.sPz,
      abtz: {
        btnSchz: icv.abtz.btnSchz,
        gridSchz: icv.abtz.gridSchz,
      },
      schClds: [
        _cr.c(LblC.N, {
          key: -50,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `伝票番号：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 't',
                  bEdit: true,
                  vle: $schz.iz1r_icn,
                  onChg: (_s: _ht.s) => {
                    $schz.iz1r_icn = _s;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -60,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `対応状況：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: true,
                  ls: icv.lz.iz1rs1100i,
                  vle: $schz.iz1rs1100i,
                  onChg: (_dz: _ht.dz) => {
                    $schz.iz1rs1100i = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -10,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `地区：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: true,
                  ls: [{ key: -1, text: ' '}].concat($i15rs),
                  vle: $schz.i11ri15r1f,
                  onChg: (_dz: _ht.dz) => {
                    $schz.i11ri15r1f = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -20,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `販売店：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 's',
                  bEdit: true,
                  ls: [{ key: -1, text: ' '}].concat($i11rs),
                  vle: $schz.i11r_fst,
                  onChg: (_dz: _ht.dz) => {
                    $schz.i11r_fst = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -30,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `店種：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: true,
                  ls: $i12rs,
                  vle: $schz.i11rt1100i,
                  onChg: (_dz: _ht.dz) => {
                    $schz.i11rt1100i = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -40,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `登録者：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: true,
                  ls: [{ key: -1, text: ' '}].concat($_10rs),
                  vle: $schz.iz1r_10r9k,
                  onChg: (_dz: _ht.dz) => {
                    $schz.iz1r_10r9k = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -70,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `受注者：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: true,
                  ls: [{ key: -1, text: ' '}].concat($_10rs),
                  vle: $schz.iz1r_10r1k,
                  onChg: (_dz: _ht.dz) => {
                    $schz.iz1r_10r1k = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -100,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `配付者：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: true,
                  ls: [{ key: -1, text: ' '}].concat($_10rs),
                  vle: $schz.iz1r_10r2k,
                  onChg: (_dz: _ht.dz) => {
                    $schz.iz1r_10r2k = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -80,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `受注日：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'd',
                  bEdit: true,
                  vle: $schz.iz1rd1100sStt,
                  onChg: (_s: _ht.s) => {
                    $schz.iz1rd1100sStt = _s;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -90,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1 - 10}`),
          lblCz: {
            text: `〜`,
            boxStlz: a(`dw/5`),
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'd',
                  bEdit: true,
                  vle: $schz.iz1rd1100sEnd,
                  onChg: (_s: _ht.s) => {
                    $schz.iz1rd1100sEnd = _s;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -110,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `配付実績日：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'd',
                  bEdit: true,
                  vle: $schz.iz1rd1200sStt,
                  onChg: (_s: _ht.s) => {
                    $schz.iz1rd1200sStt = _s;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -120,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1 - 10}`),
          lblCz: {
            text: `〜`,
            boxStlz: a(`dw/5`),
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'd',
                  bEdit: true,
                  vle: $schz.iz1rd1200sEnd,
                  onChg: (_s: _ht.s) => {
                    $schz.iz1rd1200sEnd = _s;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -140,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `支払方法：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: true,
                  ls: [{ key: -1, text: ' '}].concat($i18rs),
                  vle: $schz.i11ri18r1f,
                  onChg: (_dz: _ht.dz) => {
                    $schz.i11ri18r1f = _dz.key;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -150,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1}`),
          lblCz: {
            text: `入金確認日：`,
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'd',
                  bEdit: true,
                  vle: $schz.iz1rd1500sStt,
                  onChg: (_s: _ht.s) => {
                    $schz.iz1rd1500sStt = _s;
                  }
                }
              }),
            ]
          },
        }),
        _cr.c(LblC.N, {
          key: -160,
          abtz: icv.abtz.lblHzlz,
          boxStlz: a(`dw/${$cz.dw1 - 10}`),
          lblCz: {
            text: `〜`,
            boxStlz: a(`dw/5`),
          },
          cttCz: {
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'd',
                  bEdit: true,
                  vle: $schz.iz1rd1500sEnd,
                  onChg: (_s: _ht.s) => {
                    $schz.iz1rd1500sEnd = _s;
                  }
                }
              }),
            ]
          },
        }),
      ],
      onSch: () => $schAsync(pz.sPz.udtAll, undefined, pz.sPz),
    })
  );
};

export const T = (pz: {
  sPz: _ht.dz,
}) => {

  const _gUserz = _gv.useUserz();
  //const _udtThis = _ls.udtThis();

  React.useEffect(() => {
    if (
      _gUserz.crt._20rz._key > 0 && 
      pz.sPz.crt.steps[0] == 0
    ) {
      _hm.ectSrlAsync([
        async () => {
          //_hm.l(`icvIz1M10Rz 1752: here`);
          await $schAsync(pz.sPz.udtAll, undefined, pz.sPz, [
            async () => {
              $_10rs = await _cmFTH.loadLsAsync2({
                tgt: '_10r.load_10zLsAsync',
              });
            },
            async () => {
              $i11rs = await _cmFTH.loadLsAsync2({
                tgt: 'i11r.loadI11zLsAsync',
              });
            },
            async () => {
              $i11rs2 = await _cmFTH.loadLsAsync2({
                tgt: 'i11r.loadI11zLsAsync',
                i11rs1100i: 20,
              });
            },
            async () => {
              $i12rs = await _cmFTH.loadLsAsync2({
                tgt: 'i12r.loadI12zLsAsync',
              })
            },
            async () => {
              $i15rs = await _cmFTH.loadLsAsync2({
                tgt: 'i15r.loadI15zLsAsync',
              });
            },
            async () => {
            $i18rs = await _cmFTH.loadLsAsync2({
              tgt: 'i18r.loadI18zLsAsync',
            });
            },
            async () => {
              $i19z = await _cmFTH.loadDzAsync2({
                tgt: 'i19r.loadI19zDzAsync',
                _20r_key: _gUserz.crt._20rz._key,
              })
            },
          ]);
        },
      ])
    }
  }, [
    pz.sPz.crt.steps[0],
    _gUserz.crt._20rz._key,
  ])

//_hm.l(`icvIz1M10Rz 921: ${_hm.s(icv.abtz.textLblz)}`);
  const _hdrCs = [
    {
//      boxStlz: a(`dw/f fd/rsc mb/1`),
      cellCs: [
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `伝票番号`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `対応状況`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `地区`,
            }),
          ]
        },
        {
          boxStlz: a(`f/2`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `販売店`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `店種`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `登録者`,
            }),
          ]
        },
      ]
    },
    {
      cellCs: [
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `受注者`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `配付者`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `受注日`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `受注冊数`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `請求金額`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `配付実績日`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `支払方法`,
            }),
          ]
        },
        {
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `入金確認日`,
            }),
          ]
        },
        {
          boxStlz: a(`dw/btn f/n`),
          boxClds: [

          ]
        }
      ]
    }
  ];

  const _bdyCs = [] as _ht.ls;
  $iz1rs?.map((_iz1rz: _ht.dz, _idx: _ht.n) => {
    const _i11rz = _hm.get1(_iz1rz?.cldz?.i11rs, {});
    _bdyCs.push(
      {
        boxStlz: 
          _idx > 0 ?
            a(`bc/lt9 bs/ds bw/0 bwt/1 pt/1`)
          : undefined,
        cellCs: [
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _iz1rz._icn,
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _cm.r(icv.lz.iz1rs1100i, _iz1rz.iz1rs1100i)?.text,
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _cm.r($i15rs, _i11rz.i11ri15r1f)?.text,
              }),
            ]
          },
          {
            boxStlz: a(`f/2`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _i11rz._pfx,
                textPtyz: a(`tn/1`),
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _cm.r($i12rs, _i11rz.i11rt1100i)?.text,
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _cm.r($_10rs, _iz1rz.iz1r_10r9k)?.text,
                textPtyz: a(`tn/1`),
              }),
            ]
          },
        ]
      }
    );
    _bdyCs.push(
      {
        cellCs: [
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _cm.r($_10rs, _iz1rz.iz1r_10r1k)?.text,
                textPtyz: a(`tn/1`),
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _cm.r($_10rs, _iz1rz.iz1r_10r2k)?.text,
                textPtyz: a(`tn/1`),
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _iz1rz.iz1rd1100s,
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _iz1rz.iz1ra1100i + '冊',
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _hm.cvtCmm(_iz1rz.iz1ra4400i) + '円',
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _iz1rz.iz1rd1200s,
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _cm.r($i18rs, _i11rz.i11ri18r1f)?.text,
                textPtyz: a(`tn/1`),
              }),
            ]
          },
          {
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: _iz1rz.iz1rd1500s,
              }),
            ]
          },
          {
            boxStlz: a(`dw/btn f/n`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnDtlz,
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      if ($pz.vlez.bSch == false) { // 検索が終了している場合のみ新規追加・詳細画面表示が可能
                        $iz1r_fst = _iz1rz._fst;
                        pz.sPz.set({
                          steps: [1,0],
                          phs: 'd',
                        })
                      }
                    }
                  }            
                },
              }),

            ]
          }
        ]
      }
    );
  });

  return (
    _cr.c(TblC.N, {
      abtz: icv.abtz.tblLinez,
      hdrCz: {
        abtz: icv.abtz.gridTblHdrz,
        lineCs: _hdrCs,
      },
      bdyCz: {
        abtz: icv.abtz.gridTblBdyz,
        lineCs: _bdyCs
      }
    })

  );

};

export const C = (pz: {
  sPz: _ht.dz,
}) => {

  const _gUserz = _gv.useUserz();

  const _udtThis = _ls.udtThis();

  React.useEffect(() => {
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'c' ) { // 初期化
      $iz1z = {
        iz1rz: {
          iz1r_10r1k: _gUserz.crt._10rz._key,
          iz1r_10r9k: _gUserz.crt._10rz._key,
        },
      };
      //_hm.l(`icvIz1M10Rz 2113: here`);
      _udtThis();
    };
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd' ) { // 更新
      _cmFTH.loadDzAsync2({
        tgt: 'iz1r.loadIz1zDzAsync',
        iz1r_fst: $iz1r_fst,
        lwrz: {
          i11rs: true,
          i15rs: true,
          i18rs: true,
          _10r1s: true,
          _10r2s: true,
          _10r9s: true,
        },
      })
      .then((_iz1z: _ht.dz) => {
//_hm.l(`icvIz1M10Rz 1148: ${_hm.s(_iz1z)}`);
        $iz1z = _iz1z;
        $udtIz1z($iz1z);
//        _udtThis();
        //_hm.l(`icvIz1M10Rz 2134: here`);
        pz.sPz.udtAll(); // 納品書印刷ボタンを表示するため、_udtThis ではなく udtAll
      });
    };
  }, [
    pz.sPz.crt.steps[0],
    pz.sPz.crt.phs
  ])

  //_hm.l(`icvIz1M10Rz 2143: here`);
  return (
    _cr.c(GridC.N, {
      boxStlz: a(`dw/f dh/f pt/1`),
      lineCs: [
//        _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
        {
          boxStlz: a(`dw/f`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
/*
                _cr.c(TextC.N, {
                  pslStlz: a(`dw/f`),
                  boxStlz: a(`dw/f fd/rec`),
                  text: '※：必須',
                  textStlz: a(`tb tc/rd5 ts/s`),
                }),
*/
                _cr.c(IptC.Rqr, {
                  sPz: pz.sPz,
                })
              ]
            },
          ]
        },
//        : undefined,
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`f/1`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `伝票番号：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: false,
                          vle: $iz1z.iz1rz?._icn ?? `※ 登録時に自動付番`,
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`f/1`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `対応状況：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: false,
                          ls: icv.lz.iz1rs1100i,
                          vle: $iz1z.iz1rz?.iz1rs1100i ?? -1,
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: 
                      _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
                        `販売店： ※`
                      : `販売店：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 's',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          ls: $i11rs2, // 契約終了を除く
                          vle: $iz1z.iz1rz?.iz1ri11r1f,
                          onChg: (_dz: _ht.dz) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1ri11r1f: _dz.key,
                            });
                            _cm.u($iz1z, {
                              i11rz: _dz,
                            });
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text:
                      _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
                        `登録者： ※`
                      : `登録者：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          ls: $_10rs,
                          vle: $iz1z.iz1rz?.iz1r_10r9k,
                          onChg: (_dz: _ht.dz) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1r_10r9k: _dz.key
                            });
                            _cm.u($iz1z, {
                              _10r9z: _dz,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text:
                      _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
                        `受注者： ※`
                      : `受注者：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          ls: $_10rs,
                          vle: $iz1z.iz1rz?.iz1r_10r1k,
                          onChg: (_dz: _ht.dz) => {
//_hm.l(`icvIz1M10Rz 1301: ${_hm.s(_dz)}`);
                            _cm.u($iz1z.iz1rz, {
                              iz1r_10r1k: _dz.key,
                            })
                            _cm.u($iz1z, {
                              _10r1z: _dz,
                            });
                            $udtIz1z($iz1z);
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `配付者：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          ls: $_10rs,
                          vle: $iz1z.iz1rz?.iz1r_10r2k,
                          onChg: (_dz: _ht.dz) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1r_10r2k: _dz.key,
                            })
                            _cm.u($iz1z, {
                              _10r2z: _dz,
                            });
                            $udtIz1z($iz1z);
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text:
                      _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
                        `受注日： ※`
                      : `受注日：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'd',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $iz1z.iz1rz?.iz1rd1100s,
                          onChg: async (_s: _ht.s) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1rd1100s: _s,
                            })
                            if (!_hm.f($iz1z.iz1rz.iz1rd1220s)) {
                              let _hdys = await _cmFTH.loadLsAsync2({
                                tgt: '_60r.load_601AsAsync',
                                dateStt: _s,
                                dateEnd: _hmDTM.addMth(_s, 1),
                              });
                              _hdys = _hdys?.map((_dz: _ht.dz) => (_dz._icn));
                              let _date = _s;
                              let _cnt = 0;
                              while (_cnt < 4) {
                                _date = _hmDTM.addDay(_date, 1);
                                if (
                                  ! _hm.i(_hmDTM.cvtDow(_date), ['土', '日']) && 
                                  ! _hm.i(_date, _hdys)
                                ) {
                                  _cnt += 1;
                                };
                              }
                              _cm.u($iz1z.iz1rz, {
                                iz1rd1220s: _date,
                              })
                            }
                            $udtIz1z($iz1z);
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text:
                      _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
                        `受注冊数： ※`
                      : `受注冊数：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $iz1z.iz1rz?.iz1ra1100i,
                          onChg: (_s: _ht.s) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1ra1100i: Number(_s),
                            })
                            $udtIz1z($iz1z);
                            _udtThis();
                          },
                          cvtPfx: (_s: _ht.s) => _hm.cvtCmm(Number(_s)) + '冊'
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `販売金額：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: false,
                          vle: $iz1z.iz1rz?.iz1ra4300i,
                          cvtPfx: (_s: _ht.s) => _hm.cvtCmm(Number(_s)) + '円',
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `請求金額：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: false,
                          vle: $iz1z.iz1rz?.iz1ra4400i,
                          cvtPfx: (_s: _ht.s) => _hm.cvtCmm(Number(_s)) + '円',
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `配付予定日：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'd',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $iz1z.iz1rz?.iz1rd1220s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1rd1220s: _s,
                            })
                            $udtIz1z($iz1z);
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `配付実績日：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'd',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $iz1z.iz1rz?.iz1rd1200s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1rd1200s: _s,
                            })
                            $udtIz1z($iz1z);
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `入金確認日：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'd',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $iz1z.iz1rz?.iz1rd1500s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1rd1500s: _s
                            });
                            $udtIz1z($iz1z);
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `備考：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          bMln: true,
                          vle: $iz1z.iz1rz?.iz1ra3100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($iz1z.iz1rz, {
                              iz1ra3100s: _s
                            });
                            $udtIz1z($iz1z);
                            _udtThis();
                          },
                          iptStlz: {
                            showz: a(`dh/5`),
                            editz: a(`dh/5`),
                          },
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxStlz: a(`dw/f dh/60`),
              boxClds: [

                $iz1z.i11rz?.i11ra7110r > 0 && $iz1z.i11rz?.i11ra7120r > 0 ?
                _cr.c(LblC.N, {
                  key: -10,
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `所在地：`,
                    boxStlz: a(`dw/${$cz.lblDw}`),
                  },
                  cttCz: {
                  },
                })
                : undefined,

                $iz1z.i11rz?.i11ra7110r > 0 && $iz1z.i11rz?.i11ra7120r > 0 ?
                _cr.c(icm.Map, {
                  key: -20,
                  k: $iz1z.i11rz?.i11ra7110r,
                  i: $iz1z.i11rz?.i11ra7120r,
                })
                : undefined,

              ]
            },
          ]
        },

      ]
    })

  );

};

const $upsAsync = async (sCfmz: _ht.dz) => {
  const _b = await _hm.ectSrlAsync([
    async () => {
      let _b = true;
      if (!($iz1z.iz1rz.iz1ri11r1f > 0)) _b = false;
      if (!($iz1z.iz1rz.iz1r_10r9k > 0)) _b = false;
      if (!($iz1z.iz1rz.iz1r_10r1k > 0)) _b = false;
      if (!_hm.f($iz1z.iz1rz.iz1rd1100s)) _b = false;
      if (!($iz1z.iz1rz.iz1ra1100i > 0)) _b = false;
      if (!_b) {
        sCfmz.show({
          abtz: icv.abtz.btnNextz,
          text: '必須項目を入力してください。',
          ls: [
            { key: 1, text: 'はい' }
          ]
        })
      }
      return _b;
    },
    async () => { // 入金取り込みを考慮し、同一顧客同一注文日は不可とする
//_hm.l(`icvIz1M10Rz 1940: here`)
      let _b = true;
      const _iz1z = await _cmFTH.loadDzAsync2({
        tgt: 'iz1r.loadIz1zDzAsync',
        iz1r_fstNot: $iz1z.iz1rz._fst,
        i11r_fst: $iz1z.iz1rz.iz1ri11r1f,
        iz1rd1100s: $iz1z.iz1rz.iz1rd1100s,
      });
//_hm.l(`icvIz1M10Rz 1947: here`)
      if (_hm.f(_iz1z?.iz1rz)) _b = false;
      if (!_b) {
        sCfmz.show({
          abtz: icv.abtz.btnNextz,
          text: `同一の販売店で、同一の受注日の配付状況を複数登録することはできません。（伝票番号：${_iz1z.iz1rz._icn}）`,
          ls: [
            { key: 1, text: 'はい' }
          ]
        })
      }
      return _b;
    },
  ]);
//_hm.l(`icvIz1M10Rz 1960: here`)
  if (_b) {
//_hm.l(`icvIz1M10Rz 1962: here`)
    const _iz1z = await _cmFTH.ugdDzAsync2({
      tgt: 'iz1r.ugdIz1zDzAsync',
      iz1z: $iz1z,
    })
//_hm.l(`icvIz1M10Rz 1968: here`)
    $iz1r_fst = _iz1z.iz1rz._fst;
    return true;
  }
  else {
    return false;
  }
};

const $dltAsync = async () => {
  _hm.udtDz($iz1z.iz1rz, {
    _dlt: 1,
  });
  await _cmFTH.ugdDzAsync2({
    tgt: 'iz1r.ugdIz1zDzAsync',
    iz1z: $iz1z,
  })
};

export const B = (pz: {
  sPz: _ht.dz,
}) => {

  const _sFilez = useFilez();
  const _sCfmz = useCfmz();
  const _sLdrz = useLdrz();

  return (
    _cr.c(BtnsC.N, {
      sPz: pz.sPz,
      abtz: {
        gridBtnz: icv.abtz.gridBtnz,
        btnNextz: icv.abtz.btnNextz,
        btnBackz: icv.abtz.btnBackz,
      },
      cz: {
        tgt: $cz.tgt,
        onCrtAsync: $upsAsync,
        onAddPrs: () => {
          //_hm.l(`icvIz1M10Rz 3245: ${pz.sPz.crt.steps[0]} ${$pz.vlez.bSch}`)
          if ($pz.vlez.bSch == false) { // 検索が終了している場合のみ新規追加・詳細画面表示が可能
            pz.sPz.set({
              steps: [1],
              phs: 'c',
            })
            //_hm.l(`icvIz1M10Rz 3251: ${pz.sPz.crt.steps[0]} ${$pz.vlez.bSch}`)
          }
        },
        onUdtAsync: $upsAsync,
        onDltAsync: $dltAsync,
        atrClds: [

            pz.sPz.crt.steps[0] == 0 ?
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: icv.abtz.btnNextz,
                  lblCz: {
                    text: `配付CSVを出力`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: $eptCsv1,
                    }            
                  },
                }),

              ]
            }
            : undefined,

            pz.sPz.crt.steps[0] == 0 ?
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: icv.abtz.btnNextz,
                  lblCz: {
                    text: `請求CSVを出力`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: () => $eptCsv2(_sCfmz, _sLdrz),
                    }            
                  },
                }),

              ]
            }
            : undefined,

            pz.sPz.crt.steps[0] == 0 ?
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: icv.abtz.btnNextz,
                  lblCz: {
                    text: `入金CSVを取込`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: () => $iptCsvAsync1({
                        sPz: pz.sPz,
                        sFilez: _sFilez,
                        sCfmz: _sCfmz,
                        sLdrz: _sLdrz,
                      }),
                    }            
                  },
                }),

              ]
            }
            : undefined,

            pz.sPz.crt.steps[0] == 0 ?
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: icv.abtz.btnNextz,
                  lblCz: {
                    text: `請求書PDFを出力`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: () => $eptPdf2Async(_sCfmz, _sLdrz),
                    }            
                  },
                }),

              ]
            }
            : undefined,

            pz.sPz.crt.steps[0] == 0 ?
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: icv.abtz.btnNextz,
                  lblCz: {
                    text: `実績表EXCELを出力`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: () => $eptExl1Async(_sCfmz, _sLdrz),
                    }            
                  },
                }),

              ]
            }
            : undefined,

            pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd' && $iz1z.iz1rz?.iz1rs1100i >= 10 ? // 受注済以降
            {
              boxClds: [

                _cr.c(BtnC.N, {
                  abtz: icv.abtz.btnNextz,
                  lblCz: {
                    text: `納品書を印刷`,
                  },
                  frmCz: {
                    pslPtyz: {
                      onPrs: $eptPdf1Async
                    }            
                  },
                }),

              ]
            }
            : undefined,

        ],

      }
    })  
  );

};
